import { executeRequest, Request } from '@jfs/network'
import { Api } from '../data/models/Api'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

export const apiMappingTableParser = (dataList: any): any[] => {
  const appsList = dataList?.map((apiData: any) => {
    return {
      // id: `${apiData?.apiId}`,
      check: 'check',
      apiId: `${apiData?.apiId}`,
      appName: apiData?.appName ?? 'NA',
      status: apiData?.status,
      channelId: apiData?.channelId,
      apiEndPoint: apiData?.apiEndPoint ?? 'NA',
      exposedTo: apiData?.exposedTo,
      filterType: apiData?.filterType,
      apigwEndPoint: apiData?.apigwEndPoint ?? 'NA',
    }
  })
  return appsList
}

const getCategorisedProfileName = (profileName: string) => {
  const namesObj: any = {
    PCI_MERCHANT: 'PCI_MERCHANT',
    NON_PCI_MERCHANT: 'NON_PCI_MERCHANT',
    EMI: 'EMI',
    // EMI_NON_PCI: 'EMI',
    // 'EMI_PCI Merchant': 'EMI',
  }
  return namesObj[profileName]
}

const apisListParser = (data: any, profileName: string): any[] => {
  const apisList = data?.map((apiData: any) =>
    Api.create({
      id: `${apiData?.apiId}`,
      apiId: `${apiData?.apiId}`,
      appName: apiData?.appName ?? 'NA',
      status: apiData?.status,
      channelId: apiData?.channelId,
      apiEndPoint: apiData?.apiEndPoint ?? 'NA',
      exposedTo: apiData?.exposedTo,
      filterType: apiData?.filterType,
      apigwEndPoint: apiData?.apigwEndPoint ?? 'NA',
      isActive: apiData?.isActive ?? false,
      isSelected: apiData?.isActive ?? false,
      profileName: getCategorisedProfileName(profileName) ?? '',
    }),
  )
  return apisList
}

const responseParser = (data: any, profileName: string) => {
  if (data?.error) {
    RootStore.response.setMessage(data?.error?.message)
    return
  }
  const respData = apisListParser(data.data, profileName)
  return respData
}

const fetchApisListByChannel = (channelId: string, profileName: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.getAllApisListByChannelId,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      channelId: channelId,
      profileName: profileName,
      responseType: 'ALL',
    },
    responseType: 'text',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data, profileName)
  })
}

export { fetchApisListByChannel }
